const ROOT = "ROOT";
const ROOT_SELECTOR_NAME = "RootEditor";
const HEADER = "HEADER";
const FOOTER = "FOOTER";
const BUBBLE = "BUBBLE";
const ARTICLE_HEADER = "ARTICLE_HEADER";
const MINESTONE_M_WIDTH = 768;
const MAX_DPR = 5;
const COMPONENT_TAG = {
  SECTION: "section",
  ROW: "row",
  POPUP: "popupv1",
  BUBBLE: "contactbubble"
};

export { ARTICLE_HEADER, BUBBLE, COMPONENT_TAG, FOOTER, HEADER, MAX_DPR, MINESTONE_M_WIDTH, ROOT, ROOT_SELECTOR_NAME };
